export const OPTINS_TIMEOUT_CONFIG = {
  TIMEOUT_STEP_GET_OPTIN: 2500,
  MAX_TIMEOUT_GET_OPTIN: 30000,
};

export const TERMS_MODULE_OPTINS_TYPES_LIST = [
  { terms_and_conditions: "terms_and_conditions" },
  { purchase_data_consents: "purchase_data_consents" },
  { application_identity_consent: "application_identity_consent" },
];

export const TERMS_MODULE_OPTINS = [
  "terms_and_conditions",
  "purchase_data_consents",
  "application_identity_consent",
];

export const REGISTRIES_TO_SKIP_TERMS = [];
